module.exports = __webpack_public_path__ + "static/media/daohaus__brand--castle.37ceff51.svg";